export default "__VITE_ASSET__52517fc9__"